import React from 'react'
import { Dialog } from '@sendoutcards/quantum-design-ui'

import { PaymentSuccess } from 'src/payments/components'

type Props = {
  onClose: () => void
  isBulk?: boolean
}

const ThanksModal: React.FC<Props> = props => {
  const { onClose, isBulk } = props

  return (
    <Dialog isOpen={true} onClose={onClose} maxWidth="850px">
      <PaymentSuccess isBulk={isBulk} />
    </Dialog>
  )
}

export default ThanksModal
